module.exports = __webpack_public_path__ + "static/media/Screenshot.71d0ee69.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/Screenshot.png
// module id = 2567
// module chunks = 0